import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1080p_Series/Multimedia/Privacy_Mask/SuccessBox';
import PrivacyTable from 'components/Web_User_Interface/1080p_Series/Multimedia/Privacy_Mask/privacyTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PrivacyTable,
  BreadCrumbs,
  SEOHelmet,
  React
};